module.exports = __webpack_public_path__ + "img/react-logo.9fd3fa93.png";